import React, { useContext } from 'react';
import { UserSessionContext } from 'src/context/UserSessionContext';
import { Navigate } from 'react-router-dom';
import { Box, Container, Grid, Paper, Typography, useTheme } from '@mui/material';
import SassSvg from 'src/assets/svg/icons8-sass.svg';
import ReactSvg from 'src/assets/svg/icons8-react.svg';
import PythonPng from 'src/assets/png/python-logo-only.png';
import JavascriptPng from 'src/assets/png/icons8-javascript-48.png';
import FlaskSvg from 'src/assets/svg/icons8-flask.svg';
import DjangoSvg from 'src/assets/svg/icons8-django.svg';
import MaterialUiSvg from 'src/assets/svg/icons8-material-ui.svg';
import ProfilePicPng from 'src/assets/png/icons8-learning-100.png';
import { useDesktopMediaQuery } from 'src/hooks/useDesktopMediaQuery';
import { FadeInSection } from 'src/components/FadeInSection/FadeInSection';

const Introduction: React.FC<{ id: string }> = ({ id }) => {
  const { user, setUser } = useContext(UserSessionContext);
  const isDesktopScreenWidth = useDesktopMediaQuery();
  const theme = useTheme();
  const imageUrls = [
    JavascriptPng,
    ReactSvg,
    MaterialUiSvg,
    SassSvg,
    PythonPng,
    FlaskSvg,
    DjangoSvg,
  ];
  return (
    <Box
      id={id}
      sx={{}}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          justifyContent: 'center',
          gap: '16px',
          padding: '64px 10vw',
          overflow: 'hidden',
        }}
      >
        <FadeInSection fromDirection='front'>
          <Paper
            sx={{
              height: '250px',
              width: '250px',
              borderRadius: '100%',
              backgroundImage: `url(${ProfilePicPng})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: '65%',
              margin: '0 0 32px 0',
            }}
          ></Paper>
        </FadeInSection>
        <FadeInSection>
          <Typography variant='h4'> Software Engineer </Typography>
        </FadeInSection>
        <FadeInSection delay={200}>
          <Typography
            variant='body1'
            sx={{ margin: '32px 0' }}
          >
            Hi, I'm David! A passionate software engineer based in USA,
            California.{' '}
          </Typography>
        </FadeInSection>
        <FadeInSection>
          <Typography
            variant='h6'
            sx={{
              borderBottom: '1px solid',
              paddingBottom: '3px',
              color: theme.extendedPalette.accent.main,
            }}
          >
            Tech Stack
          </Typography>
        </FadeInSection>
        <Grid
          container
          spacing={1}
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
          {imageUrls.map((imageUrl, index) => (
            <Grid
              key={index}
              item
              xs={isDesktopScreenWidth ? 1.5 : 3}
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              <FadeInSection delay={(index + 1) * 50}>
                <Paper
                  sx={{
                    height: isDesktopScreenWidth ? '80px' : '64px',
                    width: isDesktopScreenWidth ? '80px' : '64px',
                    borderRadius: '100%',
                    backgroundImage: `url(${imageUrl})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: '65%',
                  }}
                ></Paper>
              </FadeInSection>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Introduction;
